import React from 'react';
// import { RouteObject } from 'react-router-dom';
import RedirectToPartnerId from './components/RedirectToPartnerId';

const PartnerDashboard = React.lazy(() => import('./dashboard/index'));
// const PartnerLogin = React.lazy(() => import('../components/partner/Login'));

export const partnerRoutes = [
  {
    path: '/',
    element: <PartnerDashboard />,
  },
  {
    path: '/:partnerId',
    element: <PartnerDashboard />,
  },
  {
    path: '/:partnerId/edit',
    exact: true,
    element: <PartnerDashboard isBuilder={true} />,
  },
  {
    path: '/:partnerId/view',
    exact: true,
    element: <PartnerDashboard isResumeView={true} />,
  },
  {
    path: '/:partnerId/*',
    element: <RedirectToPartnerId />,
  },
];
